import React, { useMemo } from 'react';
import SpeakerCard from '../components/speakers/SpeakerCard';
import useCsvMembers from '../hooks/useCsvMembers';
import './SpeakersPage.css';

const LocalOrganizingCommitteePage = () => {
  const members = useCsvMembers('/data/local_organizing_committee.csv');
  // Map to props expected by SpeakerCard component
  const speakers = useMemo(() => {
    if (!members) return [];
    return members.map((m) => {
    let photoPath = '';
    if (m.photo) {
      try {
        // Dynamically require the image; bundler (CRA/Vite) will include it
        photoPath = require(`../assets/local_organizing_committee/${m.photo}`);
      } catch (err) {
        console.warn(`Photo not found for ${m.name}:`, m.photo);
      }
    }
    return {
      name: m.name,
      affiliation: m.institution,
      photo: photoPath,
      bio: '',
    };
    });
  }, [members]);

  if (!members || members.length === 0) {
    return (
      <div className="loading-container">
        <div className="spinner" />
      </div>
    );
  }

  return (
    <section className="speakers-page fade-in-up">
      <div className="container-large">
        <h1 className="speakers-heading">Local Organizing Committee</h1>
        <div className="speakers-grid">
          {speakers.map((spk, idx) => (
            <SpeakerCard key={spk.name} speaker={spk} style={{ animationDelay: `${idx * 0.1}s` }} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocalOrganizingCommitteePage;
